var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9431 28.9431H30.3631L29.8031 28.4031C32.2031 25.6031 33.4431 21.7831 32.7631 17.7231C31.8231 12.1631 27.1831 7.72312 21.5831 7.04312C13.1231 6.00312 6.00315 13.1231 7.04315 21.5831C7.72315 27.1831 12.1631 31.8231 17.7231 32.7631C21.7831 33.4431 25.6031 32.2031 28.4031 29.8031L28.9431 30.3631V31.9431L37.4631 40.4431C38.2831 41.2631 39.6031 41.2631 40.4231 40.4431L40.4431 40.4231C41.2631 39.6031 41.2631 38.2831 40.4431 37.4631L31.9431 28.9431ZM19.9431 28.9431C14.9631 28.9431 10.9431 24.9231 10.9431 19.9431C10.9431 14.9631 14.9631 10.9431 19.9431 10.9431C24.9231 10.9431 28.9431 14.9631 28.9431 19.9431C28.9431 24.9231 24.9231 28.9431 19.9431 28.9431ZM15.9431 18.9431H23.9431C24.5031 18.9431 24.9431 19.3831 24.9431 19.9431C24.9431 20.5031 24.5031 20.9431 23.9431 20.9431H15.9431C15.3831 20.9431 14.9431 20.5031 14.9431 19.9431C14.9431 19.3831 15.3831 18.9431 15.9431 18.9431Z",
    fill: "#F7F5F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom_out.87ac5d7c8f6eba05d1f7e7ab93f61e27.svg";
export { ForwardRef as ReactComponent };